import React, { useState, useEffect } from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { SiGooglecalendar } from "react-icons/si";
import { useGetBatchByIdQuery } from "src/services/BatchServices";
import { SlNote } from "react-icons/sl";
import { GiTeacher } from "react-icons/gi";
import { SlCamrecorder } from "react-icons/sl";



type Props = {};

export const viewBatchTabs: {
  label: string;
  icon: IconType;
  path: string;
  moduleName: string;
  actionName: string;
}[] = [
  {
    label: "STUDENTS",
    icon: FaUser,
    path: "students",
    moduleName: UserModuleNameTypes.BATCHES,
    actionName: UserModuleActionTypes.BATCHES_STUDENTS,
  },
  {
    label: "ASSIGNMENT",
    icon: SlNote,
    path: "assignment",
    moduleName: UserModuleNameTypes.BATCHES,
    actionName: UserModuleActionTypes.BATCHES_ASSIGNMENTS,
  },
  {
    label: "ATTENDANCE",
    icon: SiGooglecalendar,
    path: "attendance",
    moduleName: UserModuleNameTypes.BATCHES,
    actionName: UserModuleActionTypes.BATCHES_ATTENDANCE,
  },
  {
    label: "LECTURE NOTES",
    icon: GiTeacher,
    path: "lecture-notes",
    moduleName: UserModuleNameTypes.BATCHES,
    actionName: UserModuleActionTypes.BATCHES_LECTURE_NOTES,
  },
  {
    label: "RECORDINGS AND NOTES",
    icon: SlCamrecorder,
    path: "recording",
    moduleName: UserModuleNameTypes.BATCHES,
    actionName: UserModuleActionTypes.BATCHES_RECORDINGS_AND_NOTES,
  },
];

const ViewBatchLayout = (props: Props) => {
  const { userType } = useSelector((state: RootState) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();
  const { batchId = "" } = useParams();

  const currentPath = location.pathname.split("/")[3];

  //QUERY
  const [bach, setBatch] = useState<any>();

  const {
    data: batchData,
    isLoading: batchisLoading,
    isFetching: batchisFetching,
  } = useGetBatchByIdQuery(batchId);

  useEffect(() => {
    if (!batchisLoading && !batchisFetching) {
      setBatch(batchData?.data);
    }
  }, [batchData, batchisLoading, batchisFetching]);

  return (
    <div className="flex flex-col gap-2 pt-3 h-full">
      {/* inquiriesEditTabs */}
      {viewBatchTabs?.length && (
        <div className="flex gap-3 items-center  mx-4  border-b border-slate-400 bg-white ">
          {viewBatchTabs
            ?.filter((module: any) =>
              userType === "ADMIN"
                ? true
                : isCheckActionsPermission({
                    moduleName: module?.moduleName,
                    actionName: module?.actionName,
                  })
            )
            ?.map((tab: any, index: any) => {
              return (
                <div key={index}>
                  <button
                    type="button"
                    onClick={() => navigate(tab.path)}
                    className={`h-full px-5 pb-2 flex gap-2 border-b-[3px]  items-center hover:text-primary-main font-medium text-[14px] transition-all
        ${
          currentPath === tab.path?.split("/")[0]
            ? "text-primary-main   border-primary-main"
            : "text-gray-700 border-white"
        }
         `}
                  >
                    <div className='text-xs'>
                      <tab.icon />
                    </div>
                    {tab.label}
                  </button>
                </div>
              );
            })}
        </div>
      )}

      {/* Outlet */}
      <div className=" flex-1 flex flex-col overflow-auto ">
        <div className="border-b border-slate-300 p-2 ml-3 sticky top-0 md:z-[1000] xs:z-[0] bg-white">
          <div className="flex gap-2 items-center">
            {/* Avatar  */}
            <div className="w-[29px] aspect-square rounded bg-primary-main text-white flex justify-center items-center text-xl font-semibold capitalize ">
              {bach?.batchName?.[0]}{" "}
            </div>
            {/* Name */}
            <div className="text-primary-dark font-semibold text-sm capitalize">
            {bach?.batchName}
            </div>
          </div>
        </div>

        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ViewBatchLayout;
